import React from "react";
import { useDisplayOrderInd } from "../../../data/trading/orderIndicative/hooks/useDisplayOrderInd";
import { DisplayDrawerContext } from "../../../layout/DisplayDrawerContext";
import { OrderIndData, OrderIndListData } from "../../../data/trading/orderIndicative/types";
import { LocalizationContext } from "../../../core/localization/Localization";
import { DisplayOrderIndMainAttributes } from "./DisplayOrderIndMainAttributes";
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  Typography,
  Grid,
} from "@material-ui/core";

export interface DisplayOrderIndProps {
  id?: number;
}

export const DisplayOrderInd: React.FunctionComponent<DisplayOrderIndProps> = ({
  id,
}) => {
  const orderInd = useDisplayOrderInd(id);
  const { getString } = React.useContext(LocalizationContext);

  return !orderInd ? (
    <>{"loading placeholder"}</>
  ) : (
    <Grid container justify="center" direction="column">
      <ExpansionPanel expanded>
        <ExpansionPanelSummary>
          <Typography>{getString("tableBasciInfo")}</Typography>
        </ExpansionPanelSummary>
        <DisplayOrderIndMainAttributes orderInd={orderInd} />
      </ExpansionPanel>
    </Grid>
  );
};

export const useViewOrderId = () => {
  const showWithDrawer = React.useContext(DisplayDrawerContext);
  return React.useCallback(
    (orderInd: OrderIndListData) => showWithDrawer(<DisplayOrderInd id={orderInd.orderIndId} />),
    [showWithDrawer]
  );
};
